import { ThemeColor } from 'src/@core/layouts/types'

export interface ReminderCategoryConfig {
  key: string
  label: string
  icon: string
  color: ThemeColor
  matcher: (fileType: string) => boolean
}

const normalize = (value: string | undefined | null) => (value || '').toLowerCase()

export const reminderCategories: ReminderCategoryConfig[] = [
  {
    key: 'ucr',
    label: 'UCR',
    icon: 'mdi:shield-home',
    color: 'info',
    matcher: type => normalize(type).includes('ucr')
  },
  {
    key: 'dotMedical',
    label: 'DOT Medical Cards',
    icon: 'mdi:medical-bag',
    color: 'error',
    matcher: type => {
      const lower = normalize(type)
      return (
        lower.includes('medical') ||
        lower.includes('medicare') ||
        lower.includes('med card') ||
        lower.includes('dot medical')
      )
    }
  },
  {
    key: 'driverLicense',
    label: 'Driver Licenses',
    icon: 'mdi:license',
    color: 'primary',
    matcher: type => {
      const lower = normalize(type)
      return lower.includes('license')
    }
  },
  {
    key: 'annualInspection',
    label: 'Annual Inspections',
    icon: 'mdi:clipboard-check-outline',
    color: 'success',
    matcher: type => {
      const lower = normalize(type)
      return lower.includes('annual') || lower.includes('inspection')
    }
  },
  {
    key: 'scac',
    label: 'Annual Renewals',
    icon: 'mdi:calendar-refresh',
    color: 'warning',
    matcher: type => {
      const lower = normalize(type)
      return lower.includes('scac') || lower.includes('annual renewal') || lower.includes('sos annual')
    }
  },
  {
    key: 'mcs150',
    label: 'Form MCS-150',
    icon: 'mdi:file-document-edit',
    color: 'secondary',
    matcher: type => {
      const lower = normalize(type)
      return lower.includes('mcs') || lower.includes('150')
    }
  }
]

export const findReminderCategory = (value?: string | null) => {
  if (!value) return undefined
  const normalized = normalize(value)
  return reminderCategories.find(category =>
    normalize(category.key) === normalized || normalize(category.label) === normalized
  )
}

export const matchesReminderCategory = (value: string | null | undefined, fileType: string | undefined) => {
  if (!value) return true
  const category = findReminderCategory(value)
  const normalizedFileType = normalize(fileType || '')
  if (category) {
    return category.matcher(normalizedFileType)
  }
  return normalizedFileType.includes(normalize(value))
}

export const getReminderCategoryDisplay = (value?: string | null) => {
  const category = findReminderCategory(value)
  return {
    label: category?.label || value || '',
    color: category?.color || 'primary',
    icon: category?.icon || 'mdi:filter-variant'
  }
}
